export default __webpack_public_path__ + "static/media/loginBackground.3282f798.svg";